import "./LaserEngravingMetal2.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import WhatIsMetalLaserEngraving from "./sections/WhatIsMetalLaserEngraving";
import WhichMetalToUse from "./sections/WhichMetalToUse";
import EngravingMarkingMethods from "./sections/EngravingMarkingMethods";
import FinishesFillColors from "./sections/FinishesFillColors";
import MetalEngravingSpecifications from "./sections/MetalEngravingSpecifications";
import ApplicationsProducts from "./sections/ApplicationsProducts";
import HowToOrder from "./sections/HowToOrder";
import DurabilityCompliance from "./sections/DurabilityCompliance";
import MetalLaserEngravingFaq from "./sections/MetalLaserEngravingFaq";
import Footer from "@/reusable_sections/Footer";
export default function LaserEngravingMetal2Page() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [{
      "@type": "Service",
      "name": "Metal Laser Engraving",
      "description": "Stainless steel, aluminum, and brass laser engraving for industrial nameplates, valve tags, and asset identification.",
      "serviceType": "Laser Engraving",
      "areaServed": "US",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Evermark Industrial Solutions"
      }
    }, {
      "@type": "WebPage",
      "@id": "https://evermark.example.com/services/laser-engraving-metal/#webpage",
      "url": "https://evermark.example.com/services/laser-engraving-metal/",
      "name": "Stainless Steel Laser Engraving | Evermark Industrial",
      "description": "Stainless steel laser engraving plus anodized aluminum & brass — metal nameplates, valve tags & asset tags. Finishes, fill colors, durable marking. Get a quote."
    }, {
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://evermark.example.com/"
      }, {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": "https://evermark.example.com/services/"
      }, {
        "@type": "ListItem",
        "position": 3,
        "name": "Laser Engraving - Metal"
      }]
    }, {
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "What metals can be laser engraved?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We specialize in stainless steel, anodized aluminum, and brass for industrial applications."
        }
      }, {
        "@type": "Question",
        "name": "How durable is laser engraving on metal?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Laser engraving is permanent and resistant to extreme heat, chemicals, and abrasion."
        }
      }, {
        "@type": "Question",
        "name": "What is the typical turnaround time?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Standard orders are typically processed within 5-7 business days."
        }
      }, {
        "@type": "Question",
        "name": "Can you add color fill to engraved metal?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we offer various color fill options for enhanced visibility and branding."
        }
      }, {
        "@type": "Question",
        "name": "Do you provide asset tagging services?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we produce high-durability asset tags and serialized nameplates."
        }
      }, {
        "@type": "Question",
        "name": "Are your tags compliant with industrial standards?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our marking methods meet or exceed most industrial and military specifications for durability."
        }
      }]
    }]
  };
  return <div>
      {}
      <title>Stainless Steel Laser Engraving | Evermark Industrial</title>
      <meta name="description" content="Stainless steel laser engraving plus anodized aluminum &amp; brass — metal nameplates, valve tags &amp; asset tags. Finishes, fill colors, durable marking. Get a quote." />
      
      <Header />
      <PageHeader />
      <WhatIsMetalLaserEngraving />
      <WhichMetalToUse />
      <EngravingMarkingMethods />
      <FinishesFillColors />
      <MetalEngravingSpecifications />
      <ApplicationsProducts />
      <HowToOrder />
      <DurabilityCompliance />
      <MetalLaserEngravingFaq />
      
      {}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLd)
    }} />
      
      <Footer />
    </div>;
}